import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint/context";
import {
    ConfluenceTemplatesUnifiedRelayPageTemplate,
    ConfluenceTemplatesUnifiedRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template";

export type ConfluenceTemplatesRelayPageProps =
    ConfluenceTemplatesUnifiedRelayPageTemplateProps & {
        mlTemplateIds?: string[];
    };

export const ConfluenceTemplatesRelayPage = ({
    queryRef,
    // @ts-ignore
    mlTemplateIds
}: ConfluenceTemplatesRelayPageProps) => {
    return (
        <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
            <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />
        </CrossFlowTouchpointProvider>
    );
};
